import axios from 'axios'

// 创建axios实例
const request = axios.create({
  baseURL: 'https://www.gyansol.com:9191',
  timeout: 10000
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 从localStorage获取当前语言
    const locale = localStorage.getItem('locale') || 'zh-CN'
    config.headers['Accept-Language'] = locale

    console.log('🌐 API Request:', {
      url: config.url,
      method: config.method?.toUpperCase(),
      'Accept-Language': config.headers['Accept-Language'],
      timestamp: new Date().toISOString()
    })

    return config
  },
  error => {
    console.error('❌ Request interceptor error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    console.log('✅ API Response:', {
      url: response.config.url,
      status: response.status,
      hasData: !!response.data,
      timestamp: new Date().toISOString()
    })
    return response.data
  },
  error => {
    console.error('❌ API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message,
      timestamp: new Date().toISOString()
    })
    return Promise.reject(error)
  }
)

/**
 * 获取产品类别列表（多语言）
 */
export function getCategories() {
  return request({
    url: '/api/i18n/categories',
    method: 'get'
  })
}

/**
 * 获取产品列表（多语言）
 * @param {Object} params 查询参数
 * @param {number} params.categoryId 类别ID，可选
 * @param {number} params.pageNum 页码
 * @param {number} params.pageSize 页大小
 */
export function getProducts(params = {}) {
  return request({
    url: '/api/i18n/products',
    method: 'get',
    params
  })
}

/**
 * 获取产品详情（多语言）
 * @param {number} id 产品ID
 */
export function getProductDetail(id) {
  return request({
    url: `/api/i18n/products/${id}`,
    method: 'get'
  })
}

export default request